module.exports = __webpack_public_path__ + "static/media/girl02.15167782.gif";